import { Checkbox, Input } from "antd";
import ConfigInputContainer from "../../../../common/components/ConfigInputContainer";
import { ICharactersGroup, IInterestingDiscussionGameConfig, Lang } from "../../../../common/types";
import { getCurrentLang } from "../../../../common/utils/lang";
import React, { ChangeEvent, Dispatch, SetStateAction } from "react";
import {CheckboxChangeEvent} from "antd/lib/checkbox";
import ConfigScreen from "../../../../common/components/game-screens/ConfigScreen";
import { ConfigSwitch } from "../../../../common/components/config-switch/ConfigSwitch";
import { useTranslation } from "react-i18next";
import Text from "../../../../common/i18n/Text";

const charactersGroups = require("../characters.json");

interface Props{
    moveBack: () => void;
    moveForward: () => void;
    config: IInterestingDiscussionGameConfig;
    changeConfig: Dispatch<SetStateAction<IInterestingDiscussionGameConfig>>;
}
const CharactersGroupSelection = ({ moveBack, moveForward, config, changeConfig}: Props) => {
    const activeLang: Lang = getCurrentLang();
    const { t } = useTranslation();

    const onChange = (groupIndex: number) => (e: CheckboxChangeEvent) => {
        const newGroups = e.target.checked
            ? [...config.selectedCharactersGroupIndexes, groupIndex]
            : config.selectedCharactersGroupIndexes.filter(index => index !== groupIndex);
        
        changeConfig((prevConfig) => ({
            ...prevConfig,
            selectedCharactersGroupIndexes: newGroups,
        }));
    };

    const handleStateChange = (property: string) => (value: any) => {
        changeConfig((prevConfig) => ({
          ...prevConfig,
          [property]: value,
        }));
    };

    const handleInputChange = (property:string) => (event: ChangeEvent<HTMLInputElement>):void => {
      handleStateChange(property)(event.target.value);
    };

    const charactersGroupsSelection = charactersGroups
        .map((group: ICharactersGroup, index: number) => {
            const name = group.name[activeLang];
            const examples = [...Array(3)].map((_, i) => " - " + group.characters[i][activeLang])
            return {value: index, name, examples};
        })
        .map(({name, value, examples}: {name: string, value: number, examples: string[]}) =>  {
            const info = <div><span><Text path="games.interesting-discussion.settings.charactersExamples"/></span><br/><ul>{examples.map(e => <li>{e}</li>)}</ul></div>
            return <ConfigInputContainer label={name} key={name} info={info}>
                <Checkbox checked={config.selectedCharactersGroupIndexes.includes(value)} onChange={onChange(value)}/>
            </ConfigInputContainer>;
        });
      
    const placeholderText = t("games.interesting-discussion.settings.placeholders-name") as string;
    
    return (
        <ConfigScreen
        configTitlePath="games.interesting-discussion.settings.title"
        backToDetails={moveBack}
        nextButtonLabelPath="games.buttons.play"
        nextToPlay={moveForward}
        nextActionDisabled={config.selectedCharactersGroupIndexes.length === 0}
        >
            <ConfigInputContainer
                labelPath="games.interesting-discussion.settings.random-topic"
                infoPath="games.interesting-discussion.settings.random-topic-info"
            >
                <ConfigSwitch
                    onChange={handleStateChange("randomTopic")}
                    checked={config.randomTopic}/>
            </ConfigInputContainer>
            {!config.randomTopic && (
              <ConfigInputContainer>
                <Input
                    placeholder={placeholderText}
                    bordered={false}
                    value={config.customTopic}
                    onChange={handleInputChange("customTopic")}
                />
              </ConfigInputContainer>
            )}
            <div className="mt-4">
                <h3><Text path="games.interesting-discussion.settings.selectCharacters"/></h3>
            </div>
            {charactersGroupsSelection}
        </ConfigScreen>
    );
};

export default CharactersGroupSelection;
